/**
 * This file is part of ONP.
 *
 * Copyright (c) Opensoft (http://opensoftdev.com)
 *
 * The unauthorized use of this code outside the boundaries of
 * Opensoft is prohibited.
 *
 * @author Ivetta Tkachenko <ivetta.tkachenko@opensoftdev.ru>
 */

define(['underscore', 'assets/js/common/router/index', 'assets/js/modules/AjaxOperation'], function(_, router, AjaxOperation) {
    var API_PRODUCT = '/api/products/{slug}';
    var API_PRODUCTS = '/api/products';

    return {
        getProduct: function(slug) {
            return new AjaxOperation(
                { name: 'Load Product' },
                {
                    type: 'get',

                    useCache: true,
                    cacheKey: 'get_product_api_' + slug,

                    url: function() {
                        return router.generate(API_PRODUCT, { slug: slug });
                    },

                    data: {}
                }
            );
        },

        getProducts: function(searchParams) {
            return new AjaxOperation(
                { name: 'Load Products by Search Params' },
                {
                    type: 'get',

                    url: function() {
                        var params = _.pick(searchParams, 'group');
                        if (params.group) {
                            params.sort = 'groupOrder';
                        }
                        return router.generate(API_PRODUCTS, params);
                    },

                    data: {}
                }
            );
        }
    };
});
